export function preventScroll() {
    document.body.style['overflow-y'] = 'hidden';
    setVariableVH();
}
export function allowScroll() {
    document.body.style['overflow-y'] = 'auto';
}
